import { createFileRoute, Outlet } from "@tanstack/react-router";
import { useProjectDetails } from "../../../domain/project/use-project-details";
import { ScenarioProvider } from "../../../features/scenario/scenario-provider";
import { trpc } from "../../../utils/trpc";

const MarginOptimizationLayout = () => {
  const projectId = useProjectDetails().id;

  const { data: scenarios, isPending } = trpc.scenario.listByProjectId.useQuery({ projectId });

  if (isPending) {
    return null;
  }

  return (
    <ScenarioProvider initialScenarios={scenarios ?? []} key={projectId}>
      <Outlet />
    </ScenarioProvider>
  );
};

export const Route = createFileRoute("/_auth/_project/margin-optimization/$projectId/$subProjectId")({
  component: MarginOptimizationLayout,
});
